module.exports = __webpack_public_path__ + "static/media/icon-search.7ca30148.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Search/icon-search.svg
// module id = 221
// module chunks = 0